export default __webpack_public_path__ + "static/Economic Model Update - Spanish-ee61261ab3a16a01dce0b67ce1a829ad.pdf";